import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';

import { SelectSharedComponent } from './select.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';

@NgModule({
    declarations: [
        SelectSharedComponent
    ],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        IconSharedModule,
        NgSelectModule
    ],
    exports: [
        SelectSharedComponent
    ]
})

export class SelectSharedModule {}
